import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import InfoModal from "./InfoModal";

/**
 * Botón de info reutilizable que abre un modal con contenido de ayuda.
 * Se integra en el header de cada panel.
 *
 * @param {{ helpContent: { title, description, sections } }} props
 */
export default function InfoButton({ helpContent }) {
  const [open, setOpen] = useState(false);

  if (!helpContent) return null;

  return (
    <>
      <Tooltip title="How does this work?" arrow>
        <IconButton
          size="small"
          onClick={() => setOpen(true)}
          sx={{
            p: 0.5,
            color: "text.secondary",
            opacity: 0.5,
            transition: "all 200ms ease",
            "&:hover": {
              opacity: 1,
              color: "#2563EB",
              bgcolor: "#EFF6FF",
            },
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>

      <InfoModal
        open={open}
        onClose={() => setOpen(false)}
        content={helpContent}
      />
    </>
  );
}
